import { render, staticRenderFns } from "./ModalHelp.vue?vue&type=template&id=523dcc76&scoped=true&"
import script from "./ModalHelp.vue?vue&type=script&lang=js&"
export * from "./ModalHelp.vue?vue&type=script&lang=js&"
import style0 from "./ModalHelp.vue?vue&type=style&index=0&id=523dcc76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523dcc76",
  null
  
)

export default component.exports